import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../components/navbar';
import Footer from '../components/footer';
import Drift from "react-driftjs";
const MyApp = () => {
    const [chat, setChat] = React.useState(false);

    React.useEffect(() => {
        setTimeout(() => {
            setChat(true);
        }, 7000)
    }, []);

    return (
        <div style={{display:'flex',flexDirection:'column'}}>
            <Navbar />
            <div style={{ marginBottom: '80px' }}></div>
            <Outlet />
            {chat ? <Drift appId="cckpef44r3gk" /> : null}
            <Footer />
        </div>
    );
}

export default MyApp